import Vue from 'vue'
import axios from 'axios'
Vue.prototype.$axios = axios // 全局注册，使用方法为:this.$axios
import qs from 'qs'
Vue.prototype.qs = qs

// Vue.prototype.$EventBus = new Vue()

import Cookies from 'js-cookie'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'
// import enLang from 'element-ui/lib/locale/lang/en'// 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖

// import '@/assets/element-#5F6770/index.css'
import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

Vue.prototype.$EventBus = new Vue() // 挂载全局传参
import './icons' // icon

import './permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters' // global filters

import VideoPlayer from 'vue-video-player'
Vue.use(VideoPlayer)

// 引入echart
import echarts from 'echarts'
Vue.prototype.$echarts = echarts



// 导入封装的URL处理方法
import { formatOssImageUrl } from './utils/urlFormat';
// 挂载到Vue原型上，所有组件可通过 this.$formatOssImageUrl 调用
Vue.prototype.$formatOssImageUrl = formatOssImageUrl;

// import 'echarts/map/js/china'

// 按需引入vue-awesome图标
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/chart-bar.js'
import 'vue-awesome/icons/chart-area.js'
import 'vue-awesome/icons/chart-pie.js'
import 'vue-awesome/icons/chart-line.js'
import 'vue-awesome/icons/align-left.js'
// 全局注册图标
Vue.component('icon', Icon)

// 引用滑过拼图验证
// import PuzzleVerification from 'vue-puzzle-verification'
// Vue.use(PuzzleVerification)

import dataV from '@jiaminghi/data-view'
Vue.use(dataV)
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }

Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
  // locale: enLang // 如果使用中文，无需设置，请删除
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// import "./assets/icons/iconfont.css";

import './assets/icons/iconfont.js'
import './assets/icons/iconfont.css'

Vue.config.productionTip = false

import {
  prodata
} from '@/utils/processingData'
Vue.prototype.$prodata = prodata // 全局注册，使用方法为:this.$axios


import { formatTime } from '@/utils/format';
Vue.filter('formatTime', formatTime);

import Tianditu from '@/utils/tianditu'
Vue.prototype.$tianditu = Tianditu

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

// 全局引入百度地图
import BaiduMap from 'vue-baidu-map'

// gZSDtOirTE33zrxpnGnp725gu7SZvGLj
// F3GtkpGzUnknPKTj1h6GePd6HTAryuKs
Vue.use(BaiduMap, {
  ak: 'F3GtkpGzUnknPKTj1h6GePd6HTAryuKs',
  v: 3
})
